import React, { useEffect, useState } from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Dropdown, DropdownButton, Table } from "react-bootstrap";
import NavBar from "../components/NavBar";
import "../styling/Setting.css";
import { Button, withStyles } from "@material-ui/core";
import Mode from "../components/Mode";
import ReactGA from "react-ga";
import { toast } from "react-toastify";
import { ReactComponent as SaveButton } from "../assets/done.svg";
import GetUser from "../services/get-user";
import userService from "../services/user-service";
import { useDispatch } from "react-redux";
import { setUserInfo } from "../redux/actions/AuthAction";
import { ReactComponent as EditPic } from "../assets/pencil.svg";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
const user = GetUser();

interface SettingsProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    //style stuff go in here
  })
);

function Set() {
  const classes = useStyles;
  const dispatch = useDispatch();
  const userID = GetUser().userID;
  var oldPassword;
  var newPassword;
  var confirmNewPassword;
  const history = useHistory();
  const [sidebar, setSidebar] = useState(false);
  const [currentProperty, setCurrentProperty] = useState("");
  const [reloadAPI,setReloadAPI] = useState(false);
  const [userDetails, setUserDetails] = useState({
    userName: "",
    userLastName: "",
    userEmail: "",
    userPassword: "",
  });

  let errorMessage = "";
  ReactGA.pageview(window.location.pathname);

  const viewTutorial = () => {
    history.push("/tutorial");
  };

  const changeDetails = (value) => {
    setCurrentProperty(value);
  };

  useEffect(() => {
    userService.getUserName().then((response) => {
      setUserDetails({
        ...userDetails,
        userEmail: `${response.data.email}`,
        userName: `${response.data.firstName}`,
        userLastName: `${response.data.lastName}`,
      });
    });
  }, [reloadAPI]);

  const saveDetails = (type, event) => {
    if (currentProperty !== "") {
      if (type === "name") {
        const value = event.target.value;
        setUserDetails({
          ...userDetails,
          userName: event.target.value,
        });
      } else if (type === "lastName") {
        const value = event.target.value;
        setUserDetails({
          ...userDetails,
          userLastName: event.target.value,
        });
      } else if (type === "email") {
        setUserDetails({
          ...userDetails,
          userEmail: event.target.value,
        });
      }
    }
  };

  const handleChangeName = () => {
    const firstName = userDetails.userName;
    const lastName = userDetails.userLastName;
    const userName = {
      firstName: userDetails.userName,
      lastName: userDetails.userLastName,
    };
    dispatch(setUserInfo(userName));
    userService
      .changeName(userID, firstName, lastName)
      .then((res) => setCurrentProperty(""))
      .catch((err) => console.log("err-->>>", err));
  };

  const setNewName = () => {
    changeDetails("name");
  };

  const setNewEmail = () => {
    changeDetails("email");
  };

  const setNewPassword = () => {
    changeDetails("password");
  };

  const handleChangeEmail = () => {
    const emailID = userDetails.userEmail;
    const password = userDetails.userPassword;
    localStorage.setItem("email", JSON.stringify({ email: emailID }));
    userService
      .changeEmail(userID, emailID,password)
      .then((res) => {
        setCurrentProperty("")
        setReloadAPI((prevState)=>!prevState)
      })
      .catch((err) =>  toast.error(err.response.data.errors));
  };

  const handlePassword = () => {
    let err = "";
    if (newPassword !== confirmNewPassword) {
      err = "Doesn't match your password!!";
    } else {
      setUserDetails({
        ...userDetails,
        userPassword: newPassword,
      });
      setCurrentProperty("");
    }
    err && toast.error(err);
    userService
      .changenewPassword(userID, oldPassword, newPassword)
      .then((res) => setCurrentProperty(""))
      .catch((err) => console.log("err-->>>", err));
  };

  return (
    <>
      <Container>
        <div className="side">
          <Sidebar sidebar={sidebar} setSidebar={setSidebar}></Sidebar>
        </div>

        <div className="Colcenter">
          <a> Overview </a>
          <Table className="tableDetails">
            <thead>
            <td className="table-header">Account Details</td>
            <td className="table-header" />
            </thead>
            <tbody>
              <tr>
                <td style={{ fontWeight: "bold", width: "33%" }}>Name</td>
                <td style={{ width: "51%" }}>
                  {currentProperty === "name" ? (
                    <>
                      <input
                        value={userDetails.userName}
                        onChange={(e) => saveDetails("name", e)}
                        className="mb-2"
                      />
                      <br />
                      <input
                        value={userDetails.userLastName}
                        onChange={(e) => saveDetails("lastName", e)}
                      />
                      <div className="mt-3 d-flex justify-content-between save-btn-wrapper">
                        <Button
                        className="mr-2 p-0"
                          onClick={() => setCurrentProperty("")}
                        >
                          cancel
                        </Button>
                        <Button
                          className="save-button ml-5"
                          onClick={handleChangeName}
                        >
                          Save
                        </Button>
                      </div>
                    </>
                  ) : (
                    <div className="show-details">
                      {`${userDetails.userName} ${userDetails.userLastName}`}{" "}
                      <EditPic className="ml-4" onClick={setNewName} />
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>Email</td>
                <td>
                  {currentProperty === "email" ? (
                    <>
                      <input
                        value={userDetails.userEmail}
                        onChange={(e) => saveDetails("email", e)}
                        className="mb-2"
                      />
                       <br />
                      <input
                        placeholder="Enter password"
                        type="password"
                        name="old-password"
                        value={userDetails.userPassword}
                        onChange={(e) => {
                          setUserDetails({
                            ...userDetails,
                            userPassword: e.target.value,
                          });
                        }}
                        className="mb-2"
                      />
                      <div className="mt-3 d-flex justify-content-between save-btn-wrapper">
                        <Button onClick={() => setCurrentProperty("")} className="mr-2 p-0">
                          Cancel
                        </Button>
                        <Button onClick={handleChangeEmail} className="save-button ml-5">Save</Button>
                      </div>
                    </>
                  ) : (
                    <div className="show-details">
                      {userDetails.userEmail}{" "}
                      <EditPic className="ml-4" onClick={setNewEmail} />
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>Password</td>
                <td>
                  {currentProperty === "password" ? (
                    <>
                      <input
                        placeholder="Enter old password"
                        type="password"
                        name="old-password"
                        value={oldPassword}
                        onChange={(e) => {
                          oldPassword = e.target.value;
                        }}
                        className="mb-2"
                      />
                      <br />
                      <input
                        placeholder="Enter new password"
                        type="password"
                        name="new-password"
                        value={newPassword}
                        onChange={(e) => {
                          newPassword = e.target.value;
                        }}
                        className="mb-2"
                      />
                      <br />
                      <input
                        placeholder="Re Enter new password"
                        type="password"
                        name="password"
                        value={confirmNewPassword}
                        onChange={(e) => {
                          confirmNewPassword = e.target.value;
                        }}
                      />
                      <div className="mt-3 d-flex justify-content-between save-btn-wrapper">
                        <Button onClick={() => setCurrentProperty("")} className="mr-2 p-0">
                          Cancel
                        </Button>
                        <Button
                         className="save-button ml-5"
                          onClick={
                             handlePassword
                          }
                        >
                          Save
                        </Button>
                      </div>
                    </>
                  ) : (
                    <span className="show-details">
                      ********{" "}
                      <EditPic className="ml-4" onClick={setNewPassword} />
                    </span>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
          <Table className="tableEmail">
            <thead>
            <td className="table-header">Email notifications</td>
            <td className="table-header" />
            </thead>
            <tbody>
              <tr>
                <td className="custom-row">Reminder to log sale to tracker</td>

                <td>
                  <div
                    className="custom-control custom-switch"
                    style={{
                      marginTop: "-2%",
                      marginBottom: "-3%",
                      marginLeft: "50%",
                    }}
                  >
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="customSwitches"
                      readOnly
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customSwitches"
                    >
                      {" "}
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="mediumBold">Weekly Summary</td>
                <td>
                  <div
                    className="custom-control custom-switch"
                    style={{
                      marginTop: "-2%",
                      marginBottom: "-3%",
                      color: "green",
                      marginLeft: "50%",
                    }}
                  >
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="customSwitchesChecked"
                      defaultChecked
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customSwitchesChecked"
                    ></label>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="mediumBold">New Features</td>
                <td>
                  <div
                    className="custom-control custom-switch"
                    style={{
                      marginTop: "-2%",
                      marginBottom: "-3%",
                      marginLeft: "50%",
                    }}
                  >
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="anotherSwitch"
                      readOnly
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="anotherSwitch"
                    >
                      {" "}
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="tablePlans">
            <div className="plansHeader">
              <span className="plans">Plans</span>
            </div>
            <div className="Line"></div>
            <div className="basicdetails">
              <div className="basicheader">
                <span className="basic">Basic</span>
                <div className="current">
                  <span id="current">Current</span>
                </div>
              </div>
              <div className="basicOption">
                <div className="optionlist">
                  <div className="checkbox"></div>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox icon={<CircleUnchecked />}   checkedIcon={<CircleCheckedFilled />}
                      />}
                      label="Sales and expense tracking"
                      className="view-goal-checkbox"
                    />
                    <FormControlLabel
                      className="view-goal-checkbox"
                      control={<Checkbox   icon={<CircleUnchecked />}   checkedIcon={<CircleCheckedFilled />}/>}
                      label="Pricing discovery tools"
                    />
                    <FormControlLabel
                      className="view-goal-checkbox"
                      control={<Checkbox  icon={<CircleUnchecked />}   checkedIcon={<CircleCheckedFilled />} />}
                      label="Analytics"
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className="premiumdetails">
              <div className="premiumheader">
                <span className="premium"> Premium</span>
              </div>
              <div className="premiumOption">
                <div className="optionlist">
                  <span className="ptext">Everything in Basic, plus:</span>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox  icon={<CircleUnchecked />}   checkedIcon={<CircleCheckedFilled />} />}
                      className="view-goal-checkbox"
                      label="Sales and expense tracking"
                    />
                    <FormControlLabel
                      control={
                          <Checkbox  icon={<CircleUnchecked />}   checkedIcon={<CircleCheckedFilled />} />
                      }
                      label="Pricing discovery tools"
                      className="view-goal-checkbox"
                    />
                    <FormControlLabel
                      className="view-goal-checkbox"
                      control={<Checkbox icon={<CircleUnchecked />}   checkedIcon={<CircleCheckedFilled />} />}
                      label="Analytics"
                    />
                  </FormGroup>
                  <div className="button">
                    <button className="subscribe">Subscribe</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Table className="tableMissed">
            <thead>
              <tr>
                <td className="table-header">
                  Missed our onboarding tutorial or want to view it again?
                </td>
                <td>
                  {" "}
                  <Button className="setBtn" onClick={viewTutorial}>
                    {" "}
                    View here
                  </Button>{" "}
                </td>
              </tr>
            </thead>
          </Table>
          <a
            style={{
              color: "red",
              marginTop: "20%",
              fontWeight: "bold",
              fontSize: "13pt",
            }}
          >
            {" "}
            Delete Account{" "}
          </a>
        </div>
      </Container>

      <Mode />
    </>
  );
}
export default Set;

function validateForm() {
  throw new Error("Function not implemented.");
}
